export default class ShopDropdown extends HTMLElement {
    open: boolean = false
    metafield: boolean = false
    dropdownEl: HTMLElement | null = null
    contentEl: HTMLElement | null = null
    textEl: HTMLElement | null = null
    iconEl: HTMLElement | null = null

    static get observedAttributes() {
        return ['open']
    }

    constructor() {
        super()

        this.metafield = this.hasAttribute('metafield') && this.getAttribute('metafield') === 'true'

        this.dropdownEl = this.querySelector<HTMLElement>('[data-dropdown]')
        this.contentEl = this.querySelector<HTMLElement>('[data-dropdown-content]')
        this.textEl = this.querySelector<HTMLElement>('[data-dropdown-text]')
        this.iconEl = this.querySelector<HTMLElement>('[data-dropdown-icon]')

        if (this.dropdownEl) {
            this.dropdownEl.addEventListener('click', this.handleClick.bind(this))
        }

        // strip out the wrapper div container tag from the content
        const content = this.textEl?.innerHTML

        if (content && this.textEl && this.metafield) {
            this.textEl.innerHTML = content?.replace(/<div[^>]*>/g, '') || ''
        }
    }

    get isOpen() {
        return this.open
    }

    set isOpen(value: boolean) {
        this.open = value
        this.setAttribute('open', value.toString())
        this.toggle()
    }

    handleClick(evt: Event) {
        evt.preventDefault()
        this.isOpen = !this.isOpen
    }

    toggle() {
        if (this.isOpen) {
            this.contentEl?.classList.remove('hidden')
            this.contentEl?.classList.add('block')
            this.dropdownEl?.classList.add('border-b')
            this.dropdownEl?.classList.add('z-[1]')
            setTimeout(() => {
                this.textEl?.classList.remove('opacity-0')
            }, 10)

            this.iconEl?.classList.add('rotate-45')
        } else {
            this.contentEl?.classList.add('hidden')
            this.contentEl?.classList.remove('block')
            this.textEl?.classList.add('opacity-0')
            this.iconEl?.classList.remove('rotate-45')
            this.dropdownEl?.classList.remove('z-[1]')
            // this.dropdownEl?.classList.remove('border-b')
        }
    }
}

customElements.define('shop-dropdown', ShopDropdown)
